module.exports = __webpack_public_path__ + "static/media/mn16.b9bbc2ec.jpeg";